import { requireComponent } from '@/utils'
import Layout from '@/layout/index.vue'
const dir = process.env.NODE_ENV === 'development' ? '/CP' : ''
const CPRouter = [
  {
    path: '/',
    redirect: `${dir}/programManagement`,
    component: Layout,
    name: 'Layout',
    children: [
      {
        path: `${dir}/programManagement`,
        component: requireComponent('CP/program-management'),
        name: 'programManagement',
        meta: {
          title: `节目管理${dir}`,
          icon: 'icon-jiemu-on'
        }
      },
      {
        path: `${dir}/programGroupManagement`,
        name: 'programGroupManagement',
        meta: {
          title: `节目集管理${dir}`,
          icon: 'icon-jiemugaikuang'
        },
        component: requireComponent('CP/program-group-management')
      },
      {
        path: '/createGroup',
        name: 'createGroup',
        meta: {
          title: '新建节目集',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/add-program-group.vue')
      },
      {
        path: '/editGroup',
        name: 'editGroup',
        meta: {
          title: '编辑节目集',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/add-program-group.vue')
      },
      {
        path: '/newGroup',
        name: 'newGroup',
        meta: {
          title: '节目编目',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/program-group.vue')
      },
      {
        path: '/managementGroup',
        name: 'managementGroup',
        meta: {
          title: '节目管理',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('CP/program-group-management/management-group.vue')
      },
      {
        path: '/upload',
        name: 'uploadVideo',
        meta: {
          title: '批量上传/客户端上传',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/upload-video.vue')
      },
      {
        path: '/uploadFile',
        name: 'uploadFile',
        meta: {
          title: '单文件上传',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/upload-file.vue')
      },
      {
        path: '/sdk',
        name: 'uploadFile',
        meta: {
          title: 'SDK上传',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/upload-sdk-file.vue')
      },
      {
        path: `${dir}/faturePlate`,
        name: 'faturePlate',
        meta: {
          title: `未来网盘${dir}`,
          icon: 'icon-weilaiwangpan-off'
        },
        component: requireComponent('CP/fature-plate')
      }
    ]
  }
]
export default CPRouter
